var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.945312 1.63804C0.945312 1.14533 1.34473 0.745911 1.83745 0.745911H19.6801C20.1728 0.745911 20.5723 1.14533 20.5723 1.63804C20.5723 2.13076 20.1728 2.53018 19.6801 2.53018H1.83745C1.34473 2.53018 0.945312 2.13076 0.945312 1.63804Z",
    fill: "#FF4B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72852 2.53018C2.72852 1.54475 3.52736 0.745911 4.51278 0.745911H17.0027C17.9881 0.745911 18.7869 1.54475 18.7869 2.53018V18.5886C18.7869 19.574 17.9881 20.3729 17.0027 20.3729H4.51278C3.52736 20.3729 2.72852 19.574 2.72852 18.5886V2.53018ZM17.0027 2.53018H4.51278V18.5886H17.0027V2.53018Z",
    fill: "#FF4B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08203 14.1279C8.08203 13.6352 8.48145 13.2358 8.97416 13.2358H12.5427C13.0354 13.2358 13.4348 13.6352 13.4348 14.1279V19.4807C13.4348 19.9734 13.0354 20.3728 12.5427 20.3728H8.97416C8.48145 20.3728 8.08203 19.9734 8.08203 19.4807V14.1279ZM9.8663 15.02V18.5886H11.6506V15.02H9.8663Z",
    fill: "#FF4B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74414 4.31445H7.63627V6.09872H6.74414V4.31445ZM10.3127 4.31445H11.2048V6.09872H10.3127V4.31445ZM13.8812 4.31445H14.7733V6.09872H13.8812V4.31445ZM6.74414 6.99085H7.63627V8.77512H6.74414V6.99085ZM10.3127 6.99085H11.2048V8.77512H10.3127V6.99085ZM12.9891 7.88299C12.9891 7.39028 13.3885 6.99085 13.8812 6.99085H14.7733C15.2661 6.99085 15.6655 7.39028 15.6655 7.88299C15.6655 8.3757 15.2661 8.77512 14.7733 8.77512H13.8812C13.3885 8.77512 12.9891 8.3757 12.9891 7.88299Z",
    fill: "#FF4B33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80354 13.5136C7.14778 11.7442 8.87506 10.5594 10.7588 10.5594C12.6433 10.5594 14.37 11.7449 14.7141 13.5138C14.892 14.4252 14.1146 15.0201 13.4352 15.0201H12.543C12.0503 15.0201 11.6509 14.6206 11.6509 14.1279C11.6509 13.6352 12.0503 13.2358 12.543 13.2358H12.6838C12.3156 12.7322 11.6331 12.3437 10.7588 12.3437C9.88454 12.3437 9.20191 12.7322 8.83369 13.2358H8.97451C9.46723 13.2358 9.86665 13.6352 9.86665 14.1279C9.86665 14.6206 9.46723 15.0201 8.97451 15.0201H8.08238C7.40287 15.0201 6.62544 14.4252 6.80354 13.5136ZM0.945312 19.4807C0.945312 18.988 1.34473 18.5886 1.83745 18.5886H19.6801C20.1728 18.5886 20.5723 18.988 20.5723 19.4807C20.5723 19.9734 20.1728 20.3729 19.6801 20.3729H1.83745C1.34473 20.3729 0.945312 19.9734 0.945312 19.4807Z",
    fill: "#FF4B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingOutline);
export default __webpack_public_path__ + "static/media/BuildingOutline.65adb044767554bd237cee887d0959f0.svg";
export { ForwardRef as ReactComponent };